import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { UnisatInjectedProvider } from '../UnisatInjectedProvider.types';

// using `unisat_wallet` instead of `unisat` to avoid conflicts with other wallets
// injecting themselves into the window.unisat object, like OneKey wallet.
const UNISAT_PROVIDER_LOCATOR = 'unisat_wallet';

export const getUnisatInjectedProvider = () => {
  return getInjectedProviderFromWindow<UnisatInjectedProvider>(
    UNISAT_PROVIDER_LOCATOR
  );
};
